import React from "react";
import "./footer.css";

const Footer = () => {
    return <div className="container footer text-center"> Ummah &copy; 2021</div>;
}

export default Footer;